<template>
  <div>
    <topup-auto-start />
  </div>
</template>

<script>
import TopupAutoStart from '@/plus/components/Topup/Auto/Start'

export default {
  name: 'TopupStartView',
  components: {
    TopupAutoStart
  }
}
</script>
